export default __webpack_public_path__ + "static/media/iss.d31ea345.jfif";